import { Grid } from '@material-ui/core';
import React from 'react';
import { batch } from 'react-redux';
import { ITender } from 'src/common/interfaces/dtos/ITender';
import { ITenderGroup } from 'src/common/interfaces/dtos/ITenderGroup';
import { BRMInputActions } from 'src/common/redux/reducers/brm-input-reducer';
import { CustomerDisplayActions } from 'src/common/redux/reducers/customer-display-reducer';
import { TenderMenuActions } from 'src/common/redux/reducers/tender-menu-reducer';
import { CustomerDisplayScreen } from 'src/customer-display/enum/customer-display.enum';
import { getCardData, hasCardData } from 'src/devices/payment/get-card-details';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { restoreSalesHomePage } from '../../common/components/emerald-home-page/emerald-home-page';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from '../../common/emerald-modal-manager/emerald-modal-manager';
import { EJRecordTypes } from '../../common/enumerations/ej-record-types';
import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import { IElectronicJournalRecord } from '../../common/interfaces/states/IElectronicJournalRecord';
import { store } from '../../common/redux/configure-store';
import { TenderingActions } from '../../common/redux/reducers/tendering-reducer';
import { TransactionActions } from '../../common/redux/reducers/transaction-reducer';
import { cancelUnPaidPreTender } from '../../home-page/business-logic/cancel-tender-payment';
import { transactionEnd } from '../../home-page/business-logic/transaction-end';
import { updateCartStatus } from '../../home-page/business-logic/update-cart-status';
import { popupAsyncMessage } from '../../messages/business-logic/popup-message';
import { couponsQuantityfn } from '../../top-area/components/coupon-quatity-helper';
import ThankYouModal from '../components/thank-you-modal/thank-you-modal';
import { findMatchingTenderInStore } from './handle-tender-payment';

export const showUnusedCouponDialog = async (): Promise<void> => {
  const unusedCouponList = store
    .getState()
    .itemList.ejItems.filter(
      i => i.Type === EJRecordTypes.Coupon && !i.Voided && i.CouponRedemptionState?.Unused,
    );

  const uniqueCouponList: IElectronicJournalRecord[] = [];
  unusedCouponList.map(x =>
    uniqueCouponList.filter(a => a.Name === x.Name).length > 0 ? null : uniqueCouponList.push(x),
  );

  const totalCoupons = unusedCouponList.reduce(
    (total, current): number => total + (current.CouponRedemptionState?.Unused ?? 0),
    0,
  );
  const couponsQuantityMapping = couponsQuantityfn(unusedCouponList, false);
  const UnusedCouponMessage = uniqueCouponList.map((item, index) => {
    return (
      <Grid item key={index} data-testid={`unused-coupon-${item.Name}`}>
        {item.Name} ({couponsQuantityMapping[item.Name]})
      </Grid>
    );
  });
  const ununsedCouponTitle = 'AllCouponView_UnusedCoupons';

  await popupAsyncMessage({
    message: ununsedCouponTitle,
    type: EmeraldDialogTypes.Info,
    subMessage: UnusedCouponMessage,
    subMessageArgs: { arg: `${totalCoupons}` },
  });
};

export const setChangeDue = (change: number): void => {
  batch(() => {
    store.dispatch(TenderingActions.setChangeDue(change));
  });
};

export const setCashback = (cashback: number): void => {
  batch(() => {
    store.dispatch(TenderingActions.setCashback(cashback));
  });
};

export const getIndexOfTenderGroup = (tender?: Partial<ITender>): number => {
  const tenderGroups = store.getState().tenderMenu.sellableTenders.tenderGroups;
  // default index for cash
  let index = 1;

  if (!tender) {
    return index;
  }

  tenderGroups.forEach((group: ITenderGroup, groupIndex: number) => {
    group.tenders.forEach((tenderInGroup: ITender) => {
      if (tenderInGroup.id === tender.id) {
        // +1 bc of action window
        index = groupIndex + 1;
      }
    });
  });

  return index;
};

export const setDefaultTenderState = (): void => {
  if (hasCardData()) {
    // find the tender group index of the tender
    const preSwipedTender = findMatchingTenderInStore(getCardData());
    const index = getIndexOfTenderGroup(preSwipedTender);
    if (preSwipedTender) {
      store.dispatch(TenderingActions.setState({ tabValue: index }));
    }
  } else {
    store.dispatch(TenderingActions.setState({ tabValue: 1 }));
  }
};

export const exitTenderingMode = async (): Promise<void> => {
  await removeTenderingView();
  await removeTotalPromotion();
};

export const removeTenderingView = async (): Promise<void> => {
  restoreSalesHomePage();
  await cancelUnPaidPreTender();
  batch((): void => {
    store.dispatch(TenderMenuActions.setSelectedTender());
    store.dispatch(TenderingActions.setIsTendering(false));
    store.dispatch(TenderingActions.setPaymentInfoText(''));

    const xlrConfig = getCurrentXLRConfig();
    if (xlrConfig.mergeBrmInputs) {
      store.dispatch(BRMInputActions.resetState());
    }
  });
};

export const showThankYou = (isPrintReceipt: boolean, openTillDrawer: boolean): void => {
  const { isTenderExchange } = store.getState().tenderExchange;
  pushEmeraldModal(
    <ThankYouModal isPrintReceipt={isPrintReceipt} openTillDrawer={openTillDrawer} />,
  );
  store.dispatch(
    CustomerDisplayActions.setScreen(
      isTenderExchange ? CustomerDisplayScreen.TenderExchange : CustomerDisplayScreen.ThankYou,
    ),
  );
};

export const dismissThankYouModal = async (): Promise<void> => {
  popEmeraldModal();
  await transactionEnd();
};

export const removeTotalPromotion = async (): Promise<void> => {
  await updateCartStatus();
  store.dispatch(TransactionActions.setIsTransactionalTotaled(false));
};
